// import React, { useEffect, useMemo, useState } from "react";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import rehypeRaw from "rehype-raw";
// import AudioPlayer from "./AudioPlayer";

// const SHARE_SEPARATOR = "------------------------------------";
// const HINDI_IMPORTANT_NOTE =
//   "\u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u0928\u094B\u091F";

// function firstNonEmpty(...values) {
//   for (const value of values) {
//     if (typeof value === "string" && value.trim()) {
//       return value.trim();
//     }
//   }

//   return "";
// }

// function normalizeCompareText(value) {
//   return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
// }

// function formatMetaLabel(value) {
//   if (!value || typeof value !== "string") {
//     return "";
//   }

//   return value
//     .replace(/[_-]+/g, " ")
//     .trim()
//     .replace(/\b\w/g, (char) => char.toUpperCase());
// }

// function flattenReactText(node) {
//   if (node === null || node === undefined || typeof node === "boolean") {
//     return "";
//   }

//   if (typeof node === "string" || typeof node === "number") {
//     return String(node);
//   }

//   if (Array.isArray(node)) {
//     return node.map(flattenReactText).join("");
//   }

//   if (React.isValidElement(node)) {
//     return flattenReactText(node.props?.children);
//   }

//   return "";
// }

// function isHeadingLikeStrong(text) {
//   const value = String(text || "").trim();

//   if (!value || value.length > 90 || /[.?!]$/.test(value)) {
//     return false;
//   }

//   return /(^[\p{Emoji_Presentation}\p{Emoji}\u2600-\u27bf])|primary|supporting|scriptural|basis|source|meaning|context|blessings|note|takeaway|answer|introduction|reflection|guidance|application|immediate|depth|अर्थ|संदर्भ|महत्वपूर्ण|मुख्य|प्राथमिक|शास्त्रीय|स्रोत|आशीर्वाद|संदेश|अभ्यास|सार|उत्तर|आध्यात्मिक|बोध/iu.test(
//     value
//   );
// }

// function normalizeHeadingLine(value) {
//   return String(value || "")
//     .replace(/[*_`>#-]/g, " ")
//     .replace(/[^\p{L}\p{N}\s]/gu, " ")
//     .replace(/\s+/g, " ")
//     .trim()
//     .toLowerCase();
// }

// function escapeRegExp(value) {
//   return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// }

// function buildFlexibleTextPattern(value) {
//   return escapeRegExp(String(value || "").trim()).replace(/\s+/g, "\\s+");
// }

// function isDisclaimerHeading(value) {
//   const normalizedLine = normalizeHeadingLine(value);

//   return (
//     normalizedLine.startsWith("important note") ||
//     normalizedLine.startsWith("महत्वपूर्ण नोट")
//   );
// }

// function hasKnownDisclaimerHeading(value) {
//   const normalizedLine = normalizeHeadingLine(value);

//   return (
//     normalizedLine.startsWith("important note") ||
//     normalizedLine.startsWith(normalizeHeadingLine(HINDI_IMPORTANT_NOTE))
//   );
// }

// function extractTrailingDisclaimerSection(value) {
//   const text = String(value || "").trim();

//   if (!text) {
//     return {
//       body: "",
//       disclaimer: "",
//     };
//   }

//   const lines = text.split("\n");
//   let disclaimerIndex = -1;

//   for (let index = 0; index < lines.length; index += 1) {
//     if (hasKnownDisclaimerHeading(lines[index])) {
//       disclaimerIndex = index;
//     }
//   }

//   if (disclaimerIndex < 0) {
//     return {
//       body: text,
//       disclaimer: "",
//     };
//   }

//   const body = lines.slice(0, disclaimerIndex).join("\n").trim();
//   const disclaimer = lines.slice(disclaimerIndex).join("\n").trim();

//   if (!body) {
//     return {
//       body: text,
//       disclaimer: "",
//     };
//   }

//   return {
//     body,
//     disclaimer,
//   };
// }

// function stripKnownDisclaimerBlock(value, disclaimerText) {
//   const text = String(value || "").trim();
//   const disclaimer = String(disclaimerText || "").trim();

//   if (!text || !disclaimer) {
//     return text;
//   }

//   const headingPattern = [
//     buildFlexibleTextPattern("Important Note"),
//     buildFlexibleTextPattern(HINDI_IMPORTANT_NOTE),
//   ].join("|");

//   const pattern = new RegExp(
//     `(?:\\n|^)\\s*(?:(?:[*_#>\\-\\s]*)?(?:${headingPattern})(?:[*_#>\\-\\s]*[:：-]?)?\\s*)?${buildFlexibleTextPattern(
//       disclaimer
//     )}\\s*$`,
//     "iu"
//   );

//   return text.replace(pattern, "").trim();
// }

// function buildAnswerModel(content, question) {
//   const emptyModel = {
//     isErrorResponse: false,
//     displayQuestion: question?.trim() || "",
//     humanEntry: "",
//     proofScripture: "",
//     proofReference: "",
//     proofVerse: "",
//     proofVerseMeaning: "",
//     hasCompactProof: false,
//     primaryAnswer: "",
//     immediateTakeaway: "",
//     depthHook: "",
//     deepAnswer: "",
//     hasDeepLayer: false,
//     languageLabel: "",
//     responseStyleLabel: "",
//     referenceText: "",
//     scriptureText: "Hindu Scriptures",
//     footerDisclaimer: "",
//     audioText: "",
//     copiedText: "",
//     fallbackText: "",
//   };

//   if (!content || typeof content !== "object") {
//     const fallbackText = String(content || "").trim();

//     return {
//       ...emptyModel,
//       primaryAnswer: fallbackText,
//       audioText: fallbackText,
//       fallbackText,
//       copiedText: [
//         "DHARMAANSWERS",
//         "Ancient wisdom for modern life",
//         SHARE_SEPARATOR,
//         question ? "QUESTION" : "",
//         question ? `"${question.trim()}"` : "",
//         fallbackText ? "" : "",
//         "ANSWER",
//         fallbackText,
//         "",
//         SHARE_SEPARATOR,
//         "Shared from DharmaAnswers",
//         "dharmaanswers.vercel.app",
//         "This answer was generated by DharmaAnswers.",
//       ]
//         .filter(Boolean)
//         .join("\n"),
//     };
//   }

//   if (content.error) {
//     const message = String(content.error || "").trim();

//     return {
//       ...emptyModel,
//       isErrorResponse: true,
//       primaryAnswer: message,
//       audioText: message,
//       fallbackText: message,
//       copiedText: message,
//       referenceText: [content.scripture, content.verse, content.reference]
//         .filter(Boolean)
//         .join(" • "),
//       scriptureText: content.scripture || "Hindu Scriptures",
//     };
//   }

//   const displayQuestion = firstNonEmpty(content.question, question);
//   const humanEntry = firstNonEmpty(content.humanEntry);
//   const rawPrimaryAnswer = firstNonEmpty(
//     content.primaryAnswer,
//     content.explanation,
//     content.answer
//   );
//   const rawDetailedAnswer = firstNonEmpty(content.detailedAnswer, content.answer);
//   const primaryExtract = extractTrailingDisclaimerSection(rawPrimaryAnswer);
//   const detailedExtract = extractTrailingDisclaimerSection(rawDetailedAnswer);
//   const footerDisclaimer = firstNonEmpty(
//     content.importantNote,
//     content.disclaimer,
//     content.note,
//     detailedExtract.disclaimer,
//     primaryExtract.disclaimer
//   );
//   const primaryAnswer = stripKnownDisclaimerBlock(
//     primaryExtract.body,
//     footerDisclaimer
//   );
//   const detailedAnswer = stripKnownDisclaimerBlock(
//     detailedExtract.body,
//     footerDisclaimer
//   );
//   const hasDeepLayer =
//     Boolean(detailedAnswer) &&
//     normalizeCompareText(detailedAnswer) !== normalizeCompareText(primaryAnswer);

//   const referenceText = [
//     content.scripture,
//     content.verse,
//     content.reference,
//   ]
//     .filter(Boolean)
//     .join(" • ");

//   const scriptureText = firstNonEmpty(content.scripture, "Hindu Scriptures");
//   const languageLabel = formatMetaLabel(content.language);
//   const responseStyleLabel = formatMetaLabel(content.responseStyle);
//   const proofScripture = firstNonEmpty(content.scripture);
//   const proofReference = firstNonEmpty(content.reference);
//   const proofVerse = firstNonEmpty(content.verse);
//   const proofVerseMeaning = stripKnownDisclaimerBlock(
//     firstNonEmpty(content.verseMeaning),
//     footerDisclaimer
//   );
//   const hasCompactProof = Boolean(
//     proofScripture || proofReference || proofVerse || proofVerseMeaning
//   );
//   const immediateTakeaway = stripKnownDisclaimerBlock(
//     firstNonEmpty(content.immediateTakeaway),
//     footerDisclaimer
//   );
//   const depthHook = stripKnownDisclaimerBlock(
//     firstNonEmpty(content.depthHook),
//     footerDisclaimer
//   );
//   const audioText = [
//     humanEntry,
//     [proofScripture, proofReference].filter(Boolean).join(" "),
//     proofVerse,
//     proofVerseMeaning,
//     primaryAnswer,
//     immediateTakeaway,
//     depthHook,
//     hasDeepLayer ? detailedAnswer : "",
//   ]
//     .filter(Boolean)
//     .join("\n\n");
//   const fallbackText = [primaryAnswer, hasDeepLayer ? detailedAnswer : ""]
//     .filter(Boolean)
//     .join("\n\n");

//   const copiedText = [
//     "DHARMAANSWERS",
//     "Ancient wisdom for modern life",
//     SHARE_SEPARATOR,
//     displayQuestion ? "QUESTION" : "",
//     displayQuestion ? `"${displayQuestion}"` : "",
//     displayQuestion ? "" : "",
//     humanEntry ? "HUMAN REFLECTION" : "",
//     humanEntry || "",
//     humanEntry ? "" : "",
//     hasCompactProof ? "PRIMARY SHLOKA PROOF" : "",
//     hasCompactProof && proofScripture ? proofScripture : "",
//     hasCompactProof && proofReference ? proofReference : "",
//     hasCompactProof && proofVerse ? proofVerse : "",
//     hasCompactProof && proofVerseMeaning ? proofVerseMeaning : "",
//     hasCompactProof ? "" : "",
//     primaryAnswer ? "PRIMARY GUIDANCE" : "",
//     primaryAnswer || "",
//     primaryAnswer ? "" : "",
//     immediateTakeaway ? "IMMEDIATE TAKEAWAY" : "",
//     immediateTakeaway || "",
//     immediateTakeaway ? "" : "",
//     depthHook ? "DEPTH HOOK" : "",
//     depthHook || "",
//     depthHook ? "" : "",
//     hasDeepLayer ? "SCRIPTURAL DEPTH" : "",
//     hasDeepLayer ? detailedAnswer : "",
//     hasDeepLayer ? "" : "",
//     referenceText ? "SCRIPTURE REFERENCE" : "",
//     referenceText || "",
//     referenceText ? "" : "",
//     SHARE_SEPARATOR,
//     "Shared from DharmaAnswers",
//     "dharmaanswers.vercel.app",
//     "This answer was generated by DharmaAnswers.",
//   ]
//     .filter(Boolean)
//     .join("\n");

//   return {
//     ...emptyModel,
//     displayQuestion,
//     humanEntry,
//     proofScripture,
//     proofReference,
//     proofVerse,
//     proofVerseMeaning,
//     hasCompactProof,
//     primaryAnswer,
//     immediateTakeaway,
//     depthHook,
//     deepAnswer: detailedAnswer,
//     hasDeepLayer,
//     languageLabel,
//     responseStyleLabel,
//     referenceText,
//     scriptureText,
//     footerDisclaimer,
//     audioText,
//     copiedText,
//     fallbackText,
//   };
// }

// export default function ScriptureAnswer({ content, question = "" }) {
//   const [copied, setCopied] = useState(false);
//   const [fadeIn, setFadeIn] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [isSmallPhone, setIsSmallPhone] = useState(false);
//   const [showDeepLayer, setShowDeepLayer] = useState(false);

//   const answerModel = useMemo(
//     () => buildAnswerModel(content, question),
//     [content, question]
//   );

//   useEffect(() => {
//     const checkScreenSize = () => {
//       const width = window.innerWidth;
//       setIsMobile(width <= 768);
//       setIsSmallPhone(width <= 480);
//     };

//     checkScreenSize();
//     window.addEventListener("resize", checkScreenSize);
//     setFadeIn(true);

//     return () => window.removeEventListener("resize", checkScreenSize);
//   }, []);

//   useEffect(() => {
//     setShowDeepLayer(false);
//   }, [content, question]);

//   const copyToClipboard = async () => {
//     try {
//       await navigator.clipboard.writeText(answerModel.copiedText);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     } catch (error) {
//       const textArea = document.createElement("textarea");
//       textArea.value = answerModel.copiedText;
//       document.body.appendChild(textArea);
//       textArea.select();
//       document.execCommand("copy");
//       document.body.removeChild(textArea);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     }
//   };

//   const markdownComponents = {
//     h1: ({ children }) => <h1 style={styles.markdownH1(isMobile)}>{children}</h1>,
//     h2: ({ children }) => <h2 style={styles.markdownH2(isMobile)}>{children}</h2>,
//     h3: ({ children }) => <h3 style={styles.markdownH3(isMobile)}>{children}</h3>,
//     p: ({ children }) => <p style={styles.markdownParagraph(isMobile)}>{children}</p>,
//     blockquote: ({ children }) => (
//       <blockquote style={styles.blockquote(isMobile)}>
//         <div style={styles.blockquoteMark(isMobile)} aria-hidden="true">
//           "
//         </div>
//         {children}
//       </blockquote>
//     ),
//     ul: ({ children }) => <ul style={styles.list(isMobile)}>{children}</ul>,
//     ol: ({ children }) => <ol style={styles.list(isMobile)}>{children}</ol>,
//     li: ({ children }) => <li style={styles.listItem(isMobile)}>{children}</li>,
//     strong: ({ children }) => {
//       const strongText = flattenReactText(children);

//       return (
//         <strong
//           style={
//             isHeadingLikeStrong(strongText)
//               ? styles.markdownStrongLabel(isMobile)
//               : styles.markdownStrong
//           }
//         >
//           {children}
//         </strong>
//       );
//     },
//     em: ({ children }) => <em style={styles.markdownEm}>{children}</em>,
//     code: ({ inline, children }) =>
//       inline ? (
//         <code style={styles.inlineCode(isMobile)}>{children}</code>
//       ) : (
//         <pre style={styles.preBlock(isMobile)}>
//           <code style={styles.codeBlock(isMobile)}>{children}</code>
//         </pre>
//       ),
//     pre: ({ children }) => <pre style={styles.preBlock(isMobile)}>{children}</pre>,
//     hr: () => <hr style={styles.rule} />,
//   };

//   const footerMarkdownComponents = {
//     h1: ({ children }) => (
//       <h4 style={styles.disclaimerHeading(isMobile)}>{children}</h4>
//     ),
//     h2: ({ children }) => (
//       <h4 style={styles.disclaimerHeading(isMobile)}>{children}</h4>
//     ),
//     h3: ({ children }) => (
//       <h4 style={styles.disclaimerHeading(isMobile)}>{children}</h4>
//     ),
//     p: ({ children }) => (
//       <p style={styles.disclaimerParagraph(isMobile)}>{children}</p>
//     ),
//     strong: ({ children }) => (
//       <strong style={styles.disclaimerStrong}>{children}</strong>
//     ),
//     em: ({ children }) => <em style={styles.disclaimerEm}>{children}</em>,
//     ul: ({ children }) => <ul style={styles.disclaimerList(isMobile)}>{children}</ul>,
//     ol: ({ children }) => <ol style={styles.disclaimerList(isMobile)}>{children}</ol>,
//     li: ({ children }) => (
//       <li style={styles.disclaimerListItem(isMobile)}>{children}</li>
//     ),
//   };

//   return (
//     <>
//       <div style={styles.shell(isMobile, isSmallPhone, fadeIn)}>
//         <div style={styles.backgroundPattern} />

//         {!answerModel.isErrorResponse && answerModel.copiedText && (
//           <div style={styles.copyButtonWrap(isMobile)}>
//             <button
//               type="button"
//               style={styles.copyButton(isMobile, copied)}
//               onClick={copyToClipboard}
//             >
//               <span>📜</span>
//               {copied ? "Copied!" : "Copy"}
//             </button>
//           </div>
//         )}

//         <header style={styles.hero(isMobile)}>
//           <div style={styles.heroMark(isMobile)} aria-hidden="true">
//             <div style={styles.heroMarkGlow} />
//             <div style={styles.heroMarkIcon(isMobile)}>🕉️</div>
//           </div>
//           <h3 style={styles.heroTitle(isMobile)}>
//             {answerModel.isErrorResponse ? "Something went wrong" : "Divine Wisdom"}
//           </h3>
//           <p style={styles.heroSubtitle(isMobile)}>
//             {answerModel.isErrorResponse
//               ? "We could not retrieve the scripture answer. Please try again."
//               : "Ancient knowledge for modern life"}
//           </p>
//         </header>

//         <div style={styles.heroDivider} />

//         <main style={styles.contentFlow(isMobile)}>
//           {answerModel.humanEntry && (
//             <section style={styles.flowSection}>
//               <h4 style={styles.sectionEyebrow(isMobile)}>
//                 A Human Reflection First
//               </h4>
//               <div style={styles.softPanel(isMobile)}>
//                 <ReactMarkdown
//                   remarkPlugins={[remarkGfm]}
//                   rehypePlugins={[rehypeRaw]}
//                   components={markdownComponents}
//                 >
//                   {answerModel.humanEntry}
//                 </ReactMarkdown>
//               </div>
//             </section>
//           )}

//           {answerModel.hasCompactProof && (
//             <section style={styles.flowSection}>
//               <div style={styles.proofBlock(isMobile)}>
//                 <div style={styles.proofMetaRow(isMobile)}>
//                   {answerModel.proofScripture && (
//                     <span style={styles.proofScripturePill(isMobile)}>
//                       📖 {answerModel.proofScripture}
//                     </span>
//                   )}
//                   {answerModel.proofReference && (
//                     <span style={styles.proofReferenceText(isMobile)}>
//                       {answerModel.proofReference}
//                     </span>
//                   )}
//                 </div>

//                 {answerModel.proofVerse && (
//                   <div style={styles.proofVerseWrap(isMobile)}>
//                     <p style={styles.proofVerseText(isMobile)}>
//                       {answerModel.proofVerse}
//                     </p>
//                   </div>
//                 )}

//                 {answerModel.proofVerseMeaning && (
//                   <p style={styles.proofMeaningText(isMobile)}>
//                     {answerModel.proofVerseMeaning}
//                   </p>
//                 )}
//               </div>
//             </section>
//           )}

//           {answerModel.primaryAnswer && (
//             <section style={styles.flowSection}>
//               <h4 style={styles.sectionEyebrow(isMobile)}>Primary Guidance</h4>
//               <div style={styles.primaryNarrative(isMobile)}>
//                 <ReactMarkdown
//                   remarkPlugins={[remarkGfm]}
//                   rehypePlugins={[rehypeRaw]}
//                   components={markdownComponents}
//                 >
//                   {answerModel.primaryAnswer}
//                 </ReactMarkdown>
//               </div>
//             </section>
//           )}

//           {answerModel.immediateTakeaway && (
//             <section style={styles.flowSection}>
//               <div style={styles.takeawayBlock(isMobile)}>
//                 <div style={styles.takeawayLabel(isMobile)}>Immediate Takeaway</div>
//                 <p style={styles.takeawayText(isMobile)}>
//                   {answerModel.immediateTakeaway}
//                 </p>
//               </div>
//             </section>
//           )}

//           {answerModel.hasDeepLayer && (
//             <section style={styles.flowSection}>
//               <button
//                 type="button"
//                 style={styles.depthToggle(isMobile)}
//                 onClick={() => setShowDeepLayer((value) => !value)}
//               >
//                 <div style={styles.depthToggleMain(isMobile)}>
//                   <div style={styles.depthToggleIcon(isMobile)}>
//                     {showDeepLayer ? "◉" : "✦"}
//                   </div>
//                   <div style={styles.depthToggleLabel(isMobile)}>
//                     {showDeepLayer
//                       ? "Hide Scriptural Depth"
//                       : "See Full Dharmic Explanation"}
//                   </div>
//                   <div style={styles.depthToggleHint(isMobile)}>
//                     {answerModel.depthHook ||
//                       "Explore the verse, meaning, and deeper dharmic context behind this answer."}
//                   </div>
//                   <div style={styles.depthToggleMeta(isMobile)}>
//                     <span style={styles.depthToggleMetaItem(isMobile)}>Verse</span>
//                     <span style={styles.depthToggleMetaDivider}>•</span>
//                     <span style={styles.depthToggleMetaItem(isMobile)}>Meaning</span>
//                     <span style={styles.depthToggleMetaDivider}>•</span>
//                     <span style={styles.depthToggleMetaItem(isMobile)}>Context</span>
//                   </div>
//                 </div>
//                 <span style={styles.depthToggleAction(isMobile, showDeepLayer)}>
//                   <span style={styles.depthToggleSymbol(isMobile)}>
//                     {showDeepLayer ? "−" : "+"}
//                   </span>
//                 </span>
//               </button>

//               {showDeepLayer && (
//                 <div style={styles.depthPanel(isMobile)}>
//                   <h4 style={styles.sectionEyebrow(isMobile)}>Scriptural Depth</h4>
//                   <ReactMarkdown
//                     remarkPlugins={[remarkGfm]}
//                     rehypePlugins={[rehypeRaw]}
//                     components={markdownComponents}
//                   >
//                     {answerModel.deepAnswer}
//                   </ReactMarkdown>
//                 </div>
//               )}
//             </section>
//           )}
//         </main>

//         {!answerModel.isErrorResponse && answerModel.audioText && (
//           <div style={styles.utilityBlock}>
//             <AudioPlayer text={answerModel.audioText} isMobile={isMobile} compact={true} />
//           </div>
//         )}

//         {!answerModel.isErrorResponse && (
//           <footer style={styles.footer(isMobile)}>
//             {answerModel.footerDisclaimer && (
//               <div style={styles.disclaimerPanel(isMobile)}>
//                 <div style={styles.disclaimerPanelGlow} />
//                 <div style={styles.disclaimerBadge(isMobile)}>AI-assisted note</div>
//                 <ReactMarkdown
//                   remarkPlugins={[remarkGfm]}
//                   rehypePlugins={[rehypeRaw]}
//                   components={footerMarkdownComponents}
//                 >
//                   {answerModel.footerDisclaimer}
//                 </ReactMarkdown>
//               </div>
//             )}

//             <div style={styles.footerBottomRow(isMobile)}>
//               <div style={styles.footerSource(isMobile)}>
//                 <span>📚</span>
//                 <span>
//                   Source: {answerModel.scriptureText || "Hindu Scriptures"}
//                 </span>
//               </div>
//               <div style={styles.footerNote(isMobile)}>
//                 Ancient wisdom for modern life
//               </div>
//             </div>
//           </footer>
//         )}
//       </div>

//       <style jsx>{`
//         @import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700;800&family=Source+Serif+4:wght@400;500;600&display=swap");
//       `}</style>
//     </>
//   );
// }

// const styles = {
//   shell: (isMobile, isSmallPhone, fadeIn) => ({
//     width: "100%",
//     background:
//       "linear-gradient(135deg, #0a0a0a 0%, #17192b 45%, #1a2740 100%)",
//     borderRadius: isSmallPhone ? "18px" : isMobile ? "22px" : "30px",
//     padding: isSmallPhone ? "18px 16px" : isMobile ? "24px 20px" : "42px 40px",
//     position: "relative",
//     overflow: "hidden",
//     border: "1px solid rgba(97, 218, 251, 0.14)",
//     boxShadow:
//       "0 28px 60px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 0 35px rgba(97, 218, 251, 0.07)",
//     opacity: fadeIn ? 1 : 0,
//     transform: fadeIn ? "translateY(0)" : "translateY(18px)",
//     transition: "all 0.6s ease-out",
//   }),
//   backgroundPattern: {
//     position: "absolute",
//     inset: 0,
//     background: `
//       radial-gradient(circle at 18% 82%, rgba(97,218,251,0.05) 0%, transparent 46%),
//       radial-gradient(circle at 82% 18%, rgba(148,187,233,0.05) 0%, transparent 44%),
//       radial-gradient(circle at 48% 34%, rgba(97,218,251,0.04) 0%, transparent 52%)
//     `,
//     pointerEvents: "none",
//     zIndex: 0,
//   },
//   copyButtonWrap: (isMobile) => ({
//     position: "absolute",
//     top: isMobile ? "14px" : "18px",
//     right: isMobile ? "14px" : "18px",
//     zIndex: 3,
//   }),
//   copyButton: (isMobile, copied) => ({
//     background: copied
//       ? "linear-gradient(135deg, rgba(72, 187, 120, 0.2) 0%, rgba(56, 161, 105, 0.2) 100%)"
//       : "linear-gradient(135deg, rgba(97, 218, 251, 0.15) 0%, rgba(33, 161, 241, 0.15) 100%)",
//     border: copied
//       ? "1px solid rgba(72, 187, 120, 0.3)"
//       : "1px solid rgba(97, 218, 251, 0.28)",
//     color: copied ? "#7ce0a1" : "#61dafb",
//     padding: isMobile ? "8px 14px" : "10px 18px",
//     borderRadius: "999px",
//     cursor: "pointer",
//     fontWeight: "700",
//     fontSize: isMobile ? "0.8rem" : "0.9rem",
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "7px",
//     backdropFilter: "blur(10px)",
//     boxShadow: copied
//       ? "0 10px 30px rgba(72, 187, 120, 0.14)"
//       : "0 8px 24px rgba(97, 218, 251, 0.12)",
//   }),
//   hero: (isMobile) => ({
//     position: "relative",
//     zIndex: 2,
//     textAlign: "center",
//     marginBottom: isMobile ? "12px" : "18px",
//     paddingTop: isMobile ? "18px" : "4px",
//   }),
//   heroMark: (isMobile) => ({
//     position: "relative",
//     width: isMobile ? "46px" : "62px",
//     height: isMobile ? "46px" : "62px",
//     margin: "0 auto 14px",
//   }),
//   heroMarkGlow: {
//     position: "absolute",
//     inset: "8%",
//     borderRadius: "16px",
//     background: "radial-gradient(circle, rgba(97, 218, 251, 0.22) 0%, rgba(97, 218, 251, 0) 74%)",
//     filter: "blur(10px)",
//   },
//   heroMarkIcon: (isMobile) => ({
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: isMobile ? "34px" : "48px",
//     lineHeight: 1,
//     filter: "drop-shadow(0 0 20px rgba(97, 218, 251, 0.4))",
//   }),
//   heroTitle: (isMobile) => ({
//     margin: 0,
//     fontFamily: "'Playfair Display', Georgia, serif",
//     fontSize: isMobile ? "1.56rem" : "2.12rem",
//     lineHeight: 1.08,
//     fontWeight: 700,
//     background:
//       "linear-gradient(135deg, #61dafb 0%, #21a1f1 48%, #94bbe9 100%)",
//     WebkitBackgroundClip: "text",
//     backgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     textShadow: "0 0 16px rgba(97, 218, 251, 0.2)",
//   }),
//   heroSubtitle: (isMobile) => ({
//     margin: isMobile ? "6px 0 0" : "8px 0 0",
//     color: "#94bbe9",
//     fontSize: isMobile ? "0.84rem" : "1rem",
//     fontStyle: "italic",
//     fontWeight: 400,
//     letterSpacing: "0.01em",
//   }),
//   heroDivider: {
//     position: "relative",
//     zIndex: 2,
//     height: "1px",
//     background: "linear-gradient(90deg, transparent, rgba(97, 218, 251, 0.25), transparent)",
//     marginBottom: "18px",
//   },
//   utilityBlock: {
//     position: "relative",
//     zIndex: 2,
//     marginTop: "6px",
//     marginBottom: "18px",
//   },
//   metaRail: (isMobile) => ({
//     display: "flex",
//     flexWrap: "wrap",
//     alignItems: "center",
//     gap: "10px",
//     marginBottom: isMobile ? "16px" : "18px",
//   }),
//   referenceRibbon: (isMobile) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     maxWidth: "100%",
//     background: "linear-gradient(135deg, rgba(97, 218, 251, 0.12) 0%, rgba(25, 57, 90, 0.36) 100%)",
//     border: "1px solid rgba(97, 218, 251, 0.2)",
//     borderRadius: "999px",
//     padding: isMobile ? "8px 13px" : "9px 15px",
//     color: "#7fdcff",
//     fontSize: isMobile ? "0.86rem" : "0.93rem",
//     fontWeight: 700,
//     lineHeight: 1.4,
//     boxShadow: "0 8px 20px rgba(97, 218, 251, 0.05)",
//   }),
//   metaChips: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "10px",
//   },
//   metaChip: (isMobile) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "6px",
//     background: "rgba(97, 218, 251, 0.08)",
//     border: "1px solid rgba(97, 218, 251, 0.18)",
//     borderRadius: "999px",
//     padding: isMobile ? "8px 14px" : "10px 16px",
//     color: "#d7ecfb",
//     fontSize: isMobile ? "0.88rem" : "0.95rem",
//     fontWeight: 600,
//   }),
//   contentFlow: (isMobile) => ({
//     position: "relative",
//     zIndex: 2,
//     maxWidth: "920px",
//     margin: "0 auto",
//     color: "#edf4fb",
//     fontFamily: "'Source Serif 4', Georgia, serif",
//     fontSize: isMobile ? "1.07rem" : "1.28rem",
//     lineHeight: 1.78,
//   }),
//   flowSection: {
//     marginBottom: "22px",
//   },
//   proofBlock: (isMobile) => ({
//     padding: isMobile ? "14px 16px" : "16px 18px",
//     borderRadius: isMobile ? "14px" : "16px",
//     background:
//       "linear-gradient(135deg, rgba(97, 218, 251, 0.08) 0%, rgba(16, 28, 42, 0.72) 100%)",
//     border: "1px solid rgba(97, 218, 251, 0.12)",
//     boxShadow: "0 10px 20px rgba(0, 0, 0, 0.12)",
//   }),
//   proofMetaRow: (isMobile) => ({
//     display: "flex",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: isMobile ? "8px" : "10px",
//     marginBottom: isMobile ? "10px" : "12px",
//   }),
//   proofScripturePill: (isMobile) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "6px",
//     padding: isMobile ? "6px 10px" : "7px 12px",
//     borderRadius: "999px",
//     background: "rgba(97, 218, 251, 0.12)",
//     border: "1px solid rgba(97, 218, 251, 0.16)",
//     color: "#a7ecff",
//     fontSize: isMobile ? "0.8rem" : "0.84rem",
//     fontWeight: 700,
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//   }),
//   proofReferenceText: (isMobile) => ({
//     color: "#c7dff3",
//     fontSize: isMobile ? "0.82rem" : "0.88rem",
//     fontWeight: 600,
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//   }),
//   proofVerseWrap: (isMobile) => ({
//     marginBottom: "10px",
//     padding: isMobile ? "12px 14px" : "13px 16px",
//     borderRadius: isMobile ? "12px" : "14px",
//     background: "rgba(8, 14, 24, 0.72)",
//     border: "1px solid rgba(97, 218, 251, 0.1)",
//   }),
//   proofVerseText: (isMobile) => ({
//     margin: 0,
//     color: "#eaf6ff",
//     fontSize: isMobile ? "0.98rem" : "1.04rem",
//     lineHeight: 1.7,
//     fontWeight: 500,
//     whiteSpace: "pre-wrap",
//   }),
//   proofMeaningText: (isMobile) => ({
//     margin: 0,
//     color: "#a9c2d8",
//     fontSize: isMobile ? "0.88rem" : "0.94rem",
//     lineHeight: 1.65,
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//     whiteSpace: "pre-wrap",
//   }),
//   sectionEyebrow: (isMobile) => ({
//     margin: "0 0 16px",
//     color: "#79d7ff",
//     fontSize: isMobile ? "1.04rem" : "1.18rem",
//     fontWeight: 700,
//     letterSpacing: "0.08em",
//     textTransform: "uppercase",
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//   }),
//   softPanel: (isMobile) => ({
//     padding: 0,
//     background: "transparent",
//     border: "none",
//     borderRadius: 0,
//     boxShadow: "none",
//   }),
//   primaryNarrative: (isMobile) => ({
//     padding: 0,
//     margin: 0,
//   }),
//   takeawayBlock: (isMobile) => ({
//     padding: isMobile ? "14px 16px" : "15px 18px",
//     borderRadius: isMobile ? "14px" : "16px",
//     background:
//       "linear-gradient(135deg, rgba(255, 255, 255, 0.028) 0%, rgba(97, 218, 251, 0.08) 100%)",
//     border: "1px solid rgba(97, 218, 251, 0.12)",
//   }),
//   takeawayLabel: (isMobile) => ({
//     marginBottom: "8px",
//     color: "#9ee6ff",
//     fontSize: isMobile ? "0.8rem" : "0.84rem",
//     fontWeight: 700,
//     letterSpacing: "0.08em",
//     textTransform: "uppercase",
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//   }),
//   takeawayText: (isMobile) => ({
//     margin: 0,
//     color: "#edf4fb",
//     fontSize: isMobile ? "0.98rem" : "1.04rem",
//     lineHeight: 1.68,
//   }),
//   depthHookText: (isMobile) => ({
//     margin: "0 0 14px",
//     color: "#aac8de",
//     fontSize: isMobile ? "0.94rem" : "1rem",
//     lineHeight: 1.65,
//     fontStyle: "italic",
//   }),
//   depthToggle: (isMobile) => ({
//     width: "100%",
//     background:
//       "linear-gradient(135deg, rgba(15, 28, 43, 0.94) 0%, rgba(18, 34, 53, 0.98) 52%, rgba(11, 22, 35, 0.96) 100%)",
//     border: "1px solid rgba(97, 218, 251, 0.14)",
//     borderRadius: isMobile ? "18px" : "20px",
//     padding: isMobile ? "13px 14px" : "14px 18px",
//     color: "#e8f6ff",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     gap: isMobile ? "12px" : "16px",
//     cursor: "pointer",
//     textAlign: "left",
//     boxShadow:
//       "0 0 0 1px rgba(255,255,255,0.02) inset, 0 14px 32px rgba(6, 12, 20, 0.16), 0 0 24px rgba(55, 183, 255, 0.08)",
//     position: "relative",
//     overflow: "hidden",
//   }),
//   depthToggleMain: (isMobile) => ({
//     display: "grid",
//     gridTemplateColumns: isMobile ? "42px 1fr" : "46px 1fr",
//     columnGap: isMobile ? "10px" : "12px",
//     rowGap: "2px",
//     alignItems: "center",
//     flex: 1,
//     minWidth: 0,
//   }),
//   depthToggleIcon: (isMobile) => ({
//     width: isMobile ? "42px" : "46px",
//     height: isMobile ? "42px" : "46px",
//     borderRadius: isMobile ? "13px" : "14px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#91ebff",
//     fontSize: isMobile ? "1.05rem" : "1.15rem",
//     background:
//       "linear-gradient(180deg, rgba(25, 73, 101, 0.88) 0%, rgba(14, 37, 58, 0.94) 100%)",
//     border: "1px solid rgba(97, 218, 251, 0.14)",
//     boxShadow:
//       "0 0 18px rgba(55, 183, 255, 0.12), inset 0 0 18px rgba(97, 218, 251, 0.06)",
//     gridRow: "1 / span 3",
//   }),
//   depthToggleLabel: (isMobile) => ({
//     fontSize: isMobile ? "1.02rem" : "1.14rem",
//     fontWeight: 700,
//     color: "#dff6ff",
//     marginBottom: "2px",
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//     lineHeight: 1.25,
//     textShadow: "0 0 10px rgba(97, 218, 251, 0.14)",
//   }),
//   depthToggleHint: (isMobile) => ({
//     color: "#a8c5db",
//     fontSize: isMobile ? "0.84rem" : "0.93rem",
//     lineHeight: 1.42,
//     marginBottom: "6px",
//   }),
//   depthToggleMeta: (isMobile) => ({
//     display: "flex",
//     alignItems: "center",
//     gap: isMobile ? "6px" : "8px",
//     flexWrap: "wrap",
//     color: "#77dfff",
//     fontSize: isMobile ? "0.74rem" : "0.78rem",
//     letterSpacing: "0.06em",
//     textTransform: "uppercase",
//     opacity: 0.92,
//   }),
//   depthToggleMetaItem: (isMobile) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     padding: isMobile ? "2px 7px" : "3px 8px",
//     borderRadius: "999px",
//     background: "rgba(97, 218, 251, 0.08)",
//     border: "1px solid rgba(97, 218, 251, 0.1)",
//     boxShadow: "0 0 12px rgba(55, 183, 255, 0.06)",
//     whiteSpace: "nowrap",
//   }),
//   depthToggleMetaDivider: {
//     color: "rgba(121, 215, 255, 0.64)",
//     fontSize: "0.8em",
//   },
//   depthToggleAction: (isMobile, isOpen) => ({
//     width: isMobile ? "42px" : "46px",
//     height: isMobile ? "42px" : "46px",
//     borderRadius: "999px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//     background: isOpen
//       ? "linear-gradient(180deg, rgba(38, 88, 120, 0.96) 0%, rgba(20, 49, 74, 0.96) 100%)"
//       : "linear-gradient(180deg, rgba(28, 62, 86, 0.88) 0%, rgba(17, 39, 59, 0.92) 100%)",
//     border: "1px solid rgba(117, 226, 255, 0.18)",
//     boxShadow:
//       "0 0 22px rgba(55, 183, 255, 0.14), inset 0 0 16px rgba(255,255,255,0.03)",
//   }),
//   depthToggleSymbol: (isMobile) => ({
//     color: "#d9f7ff",
//     fontSize: isMobile ? "1.45rem" : "1.65rem",
//     fontWeight: 600,
//     lineHeight: 1,
//     textShadow: "0 0 14px rgba(97, 218, 251, 0.18)",
//   }),
//   depthPanel: (isMobile) => ({
//     marginTop: "12px",
//     padding: 0,
//     background: "rgba(255, 255, 255, 0.015)",
//     border: "none",
//     borderRadius: isMobile ? "12px" : "14px",
//     boxShadow: "none",
//   }),
//   footer: (isMobile) => ({
//     position: "relative",
//     zIndex: 2,
//     marginTop: "34px",
//     paddingTop: "24px",
//     borderTop: "1px solid rgba(97, 218, 251, 0.16)",
//   }),
//   disclaimerPanel: (isMobile) => ({
//     position: "relative",
//     display: "block",
//     padding: isMobile ? "18px" : "20px 22px",
//     borderRadius: isMobile ? "16px" : "18px",
//     background:
//       "linear-gradient(135deg, rgba(10, 16, 25, 0.95) 0%, rgba(16, 23, 36, 0.96) 58%, rgba(12, 18, 29, 0.98) 100%)",
//     border: "1px solid rgba(148, 187, 233, 0.12)",
//     boxShadow:
//       "0 14px 30px rgba(0, 0, 0, 0.16), inset 0 1px 0 rgba(255,255,255,0.02), inset 3px 0 0 rgba(97, 218, 251, 0.18)",
//     overflow: "hidden",
//   }),
//   disclaimerPanelGlow: {
//     position: "absolute",
//     inset: 0,
//     background:
//       "radial-gradient(circle at top right, rgba(97, 218, 251, 0.08) 0%, transparent 34%), radial-gradient(circle at bottom left, rgba(148, 187, 233, 0.06) 0%, transparent 28%)",
//     pointerEvents: "none",
//   },
//   disclaimerBadge: (isMobile) => ({
//     position: "relative",
//     zIndex: 1,
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "6px",
//     marginBottom: "12px",
//     padding: isMobile ? "6px 10px" : "7px 12px",
//     borderRadius: "999px",
//     background: "rgba(97, 218, 251, 0.08)",
//     border: "1px solid rgba(97, 218, 251, 0.14)",
//     color: "#9edfff",
//     fontSize: isMobile ? "0.76rem" : "0.8rem",
//     fontWeight: 700,
//     letterSpacing: "0.06em",
//     textTransform: "uppercase",
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//     boxShadow: "inset 0 1px 0 rgba(255,255,255,0.03)",
//   }),
//   disclaimerHeading: (isMobile) => ({
//     position: "relative",
//     zIndex: 1,
//     margin: "0 0 10px",
//     color: "#d4f2ff",
//     fontSize: isMobile ? "0.96rem" : "1.02rem",
//     fontWeight: 700,
//     letterSpacing: "0.02em",
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//   }),
//   disclaimerParagraph: (isMobile) => ({
//     position: "relative",
//     zIndex: 1,
//     margin: 0,
//     color: "#9fb7ce",
//     fontSize: isMobile ? "0.85rem" : "0.91rem",
//     lineHeight: 1.72,
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//   }),
//   disclaimerStrong: {
//     color: "#ccefff",
//     fontWeight: 700,
//   },
//   disclaimerEm: {
//     color: "#a8dbff",
//     fontStyle: "italic",
//   },
//   disclaimerList: (isMobile) => ({
//     margin: "8px 0 0",
//     paddingLeft: isMobile ? "18px" : "20px",
//     color: "#8fa8c1",
//   }),
//   disclaimerListItem: (isMobile) => ({
//     marginBottom: "6px",
//     fontSize: isMobile ? "0.84rem" : "0.9rem",
//     lineHeight: 1.65,
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//   }),
//   footerBottomRow: (isMobile) => ({
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: isMobile ? "flex-start" : "center",
//     flexDirection: isMobile ? "column" : "row",
//     gap: isMobile ? "10px" : "18px",
//     marginTop: "18px",
//   }),
//   footerSource: (isMobile) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "8px",
//     color: "#a8c1d7",
//     fontSize: isMobile ? "0.92rem" : "1rem",
//   }),
//   footerNote: (isMobile) => ({
//     color: "#61dafb",
//     fontSize: isMobile ? "0.9rem" : "0.98rem",
//     fontStyle: "italic",
//     fontWeight: 600,
//   }),
//   markdownH1: (isMobile) => ({
//     margin: "0 0 18px",
//     fontFamily: "'Playfair Display', Georgia, serif",
//     fontSize: isMobile ? "1.7rem" : "2rem",
//     color: "#7fdcff",
//     lineHeight: 1.2,
//     textShadow: "0 0 18px rgba(97, 218, 251, 0.16)",
//   }),
//   markdownH2: (isMobile) => ({
//     margin: "24px 0 14px",
//     fontFamily: "'Playfair Display', Georgia, serif",
//     fontSize: isMobile ? "1.45rem" : "1.65rem",
//     color: "#7fdcff",
//     lineHeight: 1.28,
//     textShadow: "0 0 14px rgba(97, 218, 251, 0.12)",
//   }),
//   markdownH3: (isMobile) => ({
//     margin: "20px 0 12px",
//     fontFamily: "'Playfair Display', Georgia, serif",
//     fontSize: isMobile ? "1.2rem" : "1.35rem",
//     color: "#9adfff",
//     lineHeight: 1.34,
//     textShadow: "0 0 12px rgba(97, 218, 251, 0.1)",
//   }),
//   markdownParagraph: (isMobile) => ({
//     margin: "0 0 22px",
//     color: "#e6edf8",
//     fontSize: isMobile ? "1.05rem" : "1.26rem",
//     lineHeight: 1.78,
//     textAlign: "left",
//   }),
//   markdownStrong: {
//     color: "#67d8ff",
//     fontWeight: 700,
//     textShadow: "0 0 10px rgba(97, 218, 251, 0.16)",
//   },
//   markdownStrongLabel: (isMobile) => ({
//     display: "inline-block",
//     padding: isMobile ? "3px 10px 5px" : "4px 12px 6px",
//     marginRight: "8px",
//     marginBottom: "4px",
//     borderRadius: "10px",
//     background:
//       "linear-gradient(180deg, rgba(30, 78, 112, 0.96) 0%, rgba(18, 48, 71, 0.92) 100%)",
//     border: "1px solid rgba(117, 226, 255, 0.16)",
//     boxShadow:
//       "0 0 0 1px rgba(255, 255, 255, 0.02) inset, 0 0 20px rgba(60, 189, 255, 0.14)",
//     color: "#79e3ff",
//     fontWeight: 700,
//     letterSpacing: "0.01em",
//     lineHeight: 1.25,
//     textShadow: "0 0 12px rgba(97, 218, 251, 0.22)",
//     verticalAlign: "baseline",
//   }),
//   markdownEm: {
//     color: "#9ed4ff",
//     fontStyle: "italic",
//   },
//   blockquote: (isMobile) => ({
//     position: "relative",
//     margin: "26px 0",
//     padding: isMobile ? "18px 18px 18px 24px" : "24px 28px 24px 30px",
//     borderRadius: "18px",
//     border: "1px solid rgba(97, 218, 251, 0.16)",
//     background:
//       "linear-gradient(135deg, rgba(97, 218, 251, 0.08) 0%, rgba(148, 187, 233, 0.06) 100%)",
//     color: "#f2fbff",
//   }),
//   blockquoteMark: (isMobile) => ({
//     position: "absolute",
//     left: isMobile ? "8px" : "10px",
//     top: isMobile ? "-4px" : "-8px",
//     color: "rgba(97, 218, 251, 0.3)",
//     fontSize: isMobile ? "2.2rem" : "3rem",
//     fontFamily: "Georgia, serif",
//     lineHeight: 1,
//   }),
//   list: (isMobile) => ({
//     paddingLeft: isMobile ? "20px" : "26px",
//     margin: "18px 0 24px",
//   }),
//   listItem: (isMobile) => ({
//     marginBottom: "10px",
//     color: "#e6edf8",
//     fontSize: isMobile ? "1.02rem" : "1.2rem",
//     lineHeight: 1.7,
//   }),
//   inlineCode: (isMobile) => ({
//     background: "rgba(97, 218, 251, 0.1)",
//     color: "#7fdcff",
//     borderRadius: "6px",
//     padding: isMobile ? "2px 6px" : "3px 8px",
//     fontSize: isMobile ? "0.92rem" : "0.98rem",
//     fontFamily: "'Fira Code', 'Courier New', monospace",
//   }),
//   preBlock: (isMobile) => ({
//     background: "rgba(11, 18, 30, 0.9)",
//     border: "1px solid rgba(97, 218, 251, 0.16)",
//     borderRadius: "18px",
//     padding: isMobile ? "16px 16px" : "20px 22px",
//     margin: "24px 0",
//     overflowX: "auto",
//     WebkitOverflowScrolling: "touch",
//   }),
//   codeBlock: (isMobile) => ({
//     color: "#d8f7ff",
//     fontSize: isMobile ? "0.98rem" : "1.08rem",
//     fontFamily: "'Fira Code', 'Courier New', monospace",
//     whiteSpace: "pre",
//     lineHeight: 1.7,
//   }),
//   rule: {
//     border: "none",
//     height: "1px",
//     background:
//       "linear-gradient(90deg, transparent, rgba(97, 218, 251, 0.24), transparent)",
//     margin: "28px 0",
//   },
// };








import React, { useEffect, useMemo, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import AudioPlayer from "./AudioPlayer";

const SHARE_SEPARATOR = "------------------------------------";
const HINDI_IMPORTANT_NOTE =
  "\u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u0928\u094B\u091F";

function firstNonEmpty(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return "";
}

function normalizeCompareText(value) {
  return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
}

function formatMetaLabel(value) {
  if (!value || typeof value !== "string") {
    return "";
  }
  return value
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function flattenReactText(node) {
  if (node === null || node === undefined || typeof node === "boolean") {
    return "";
  }
  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(flattenReactText).join("");
  }
  if (React.isValidElement(node)) {
    return flattenReactText(node.props?.children);
  }
  return "";
}

function isHeadingLikeStrong(text) {
  const value = String(text || "").trim();
  if (!value || value.length > 90 || /[.?!]$/.test(value)) {
    return false;
  }
  return /(^[\p{Emoji_Presentation}\p{Emoji}\u2600-\u27bf])|primary|supporting|scriptural|basis|source|meaning|context|blessings|note|takeaway|answer|introduction|reflection|guidance|application|immediate|depth|अर्थ|संदर्भ|महत्वपूर्ण|मुख्य|प्राथमिक|शास्त्रीय|स्रोत|आशीर्वाद|संदेश|अभ्यास|सार|उत्तर|आध्यात्मिक|बोध/iu.test(
    value
  );
}

function normalizeHeadingLine(value) {
  return String(value || "")
    .replace(/[*_`>#-]/g, " ")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function escapeRegExp(value) {
  return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function buildFlexibleTextPattern(value) {
  return escapeRegExp(String(value || "").trim()).replace(/\s+/g, "\\s+");
}

function hasKnownDisclaimerHeading(value) {
  const normalizedLine = normalizeHeadingLine(value);
  return (
    normalizedLine.startsWith("important note") ||
    normalizedLine.startsWith(normalizeHeadingLine(HINDI_IMPORTANT_NOTE))
  );
}

function extractTrailingDisclaimerSection(value) {
  const text = String(value || "").trim();
  if (!text) {
    return { body: "", disclaimer: "" };
  }
  const lines = text.split("\n");
  let disclaimerIndex = -1;
  for (let index = 0; index < lines.length; index += 1) {
    if (hasKnownDisclaimerHeading(lines[index])) {
      disclaimerIndex = index;
    }
  }
  if (disclaimerIndex < 0) {
    return { body: text, disclaimer: "" };
  }
  const body = lines.slice(0, disclaimerIndex).join("\n").trim();
  const disclaimer = lines.slice(disclaimerIndex).join("\n").trim();
  if (!body) {
    return { body: text, disclaimer: "" };
  }
  return { body, disclaimer };
}

function stripKnownDisclaimerBlock(value, disclaimerText) {
  const text = String(value || "").trim();
  const disclaimer = String(disclaimerText || "").trim();
  if (!text || !disclaimer) {
    return text;
  }
  const headingPattern = [
    buildFlexibleTextPattern("Important Note"),
    buildFlexibleTextPattern(HINDI_IMPORTANT_NOTE),
  ].join("|");
  const pattern = new RegExp(
    `(?:\\n|^)\\s*(?:(?:[*_#>\\-\\s]*)?(?:${headingPattern})(?:[*_#>\\-\\s]*[:：-]?)?\\s*)?${buildFlexibleTextPattern(
      disclaimer
    )}\\s*$`,
    "iu"
  );
  return text.replace(pattern, "").trim();
}

function buildAnswerModel(content, question) {
  const emptyModel = {
    isErrorResponse: false,
    displayQuestion: question?.trim() || "",
    humanEntry: "",
    proofScripture: "",
    proofReference: "",
    proofVerse: "",
    proofVerseMeaning: "",
    hasCompactProof: false,
    primaryAnswer: "",
    immediateTakeaway: "",
    depthHook: "",
    deepAnswer: "",
    hasDeepLayer: false,
    languageLabel: "",
    responseStyleLabel: "",
    referenceText: "",
    scriptureText: "Hindu Scriptures",
    footerDisclaimer: "",
    audioText: "",
    copiedText: "",
    fallbackText: "",
  };

  if (!content || typeof content !== "object") {
    const fallbackText = String(content || "").trim();
    return {
      ...emptyModel,
      primaryAnswer: fallbackText,
      audioText: fallbackText,
      fallbackText,
      copiedText: [
        "DHARMAANSWERS",
        "Ancient wisdom for modern life",
        SHARE_SEPARATOR,
        question ? "QUESTION" : "",
        question ? `"${question.trim()}"` : "",
        fallbackText ? "" : "",
        "ANSWER",
        fallbackText,
        "",
        SHARE_SEPARATOR,
        "Shared from DharmaAnswers",
        "dharmaanswers.vercel.app",
        "This answer was generated by DharmaAnswers.",
      ]
        .filter(Boolean)
        .join("\n"),
    };
  }

  if (content.error) {
    const message = String(content.error || "").trim();
    return {
      ...emptyModel,
      isErrorResponse: true,
      primaryAnswer: message,
      audioText: message,
      fallbackText: message,
      copiedText: message,
      referenceText: [content.scripture, content.verse, content.reference]
        .filter(Boolean)
        .join(" • "),
      scriptureText: content.scripture || "Hindu Scriptures",
    };
  }

  const displayQuestion = firstNonEmpty(content.question, question);
  const humanEntry = firstNonEmpty(content.humanEntry);
  const rawPrimaryAnswer = firstNonEmpty(
    content.primaryAnswer,
    content.explanation,
    content.answer
  );
  const rawDetailedAnswer = firstNonEmpty(content.detailedAnswer, content.answer);
  const primaryExtract = extractTrailingDisclaimerSection(rawPrimaryAnswer);
  const detailedExtract = extractTrailingDisclaimerSection(rawDetailedAnswer);
  const footerDisclaimer = firstNonEmpty(
    content.importantNote,
    content.disclaimer,
    content.note,
    detailedExtract.disclaimer,
    primaryExtract.disclaimer
  );
  const primaryAnswer = stripKnownDisclaimerBlock(
    primaryExtract.body,
    footerDisclaimer
  );
  const detailedAnswer = stripKnownDisclaimerBlock(
    detailedExtract.body,
    footerDisclaimer
  );
  const hasDeepLayer =
    Boolean(detailedAnswer) &&
    normalizeCompareText(detailedAnswer) !== normalizeCompareText(primaryAnswer);

  const referenceText = [content.scripture, content.verse, content.reference]
    .filter(Boolean)
    .join(" • ");

  const scriptureText = firstNonEmpty(content.scripture, "Hindu Scriptures");
  const languageLabel = formatMetaLabel(content.language);
  const responseStyleLabel = formatMetaLabel(content.responseStyle);
  const proofScripture = firstNonEmpty(content.scripture);
  const proofReference = firstNonEmpty(content.reference);
  const proofVerse = firstNonEmpty(content.verse);
  const proofVerseMeaning = stripKnownDisclaimerBlock(
    firstNonEmpty(content.verseMeaning),
    footerDisclaimer
  );
  const hasCompactProof = Boolean(
    proofScripture || proofReference || proofVerse || proofVerseMeaning
  );
  const immediateTakeaway = stripKnownDisclaimerBlock(
    firstNonEmpty(content.immediateTakeaway),
    footerDisclaimer
  );
  const depthHook = stripKnownDisclaimerBlock(
    firstNonEmpty(content.depthHook),
    footerDisclaimer
  );
  const audioText = [
    humanEntry,
    [proofScripture, proofReference].filter(Boolean).join(" "),
    proofVerse,
    proofVerseMeaning,
    primaryAnswer,
    immediateTakeaway,
    depthHook,
    hasDeepLayer ? detailedAnswer : "",
  ]
    .filter(Boolean)
    .join("\n\n");
  const fallbackText = [primaryAnswer, hasDeepLayer ? detailedAnswer : ""]
    .filter(Boolean)
    .join("\n\n");

  const copiedText = [
    "DHARMAANSWERS",
    "Ancient wisdom for modern life",
    SHARE_SEPARATOR,
    displayQuestion ? "QUESTION" : "",
    displayQuestion ? `"${displayQuestion}"` : "",
    displayQuestion ? "" : "",
    humanEntry ? "HUMAN REFLECTION" : "",
    humanEntry || "",
    humanEntry ? "" : "",
    hasCompactProof ? "PRIMARY SHLOKA PROOF" : "",
    hasCompactProof && proofScripture ? proofScripture : "",
    hasCompactProof && proofReference ? proofReference : "",
    hasCompactProof && proofVerse ? proofVerse : "",
    hasCompactProof && proofVerseMeaning ? proofVerseMeaning : "",
    hasCompactProof ? "" : "",
    primaryAnswer ? "PRIMARY GUIDANCE" : "",
    primaryAnswer || "",
    primaryAnswer ? "" : "",
    immediateTakeaway ? "IMMEDIATE TAKEAWAY" : "",
    immediateTakeaway || "",
    immediateTakeaway ? "" : "",
    depthHook ? "DEPTH HOOK" : "",
    depthHook || "",
    depthHook ? "" : "",
    hasDeepLayer ? "SCRIPTURAL DEPTH" : "",
    hasDeepLayer ? detailedAnswer : "",
    hasDeepLayer ? "" : "",
    referenceText ? "SCRIPTURE REFERENCE" : "",
    referenceText || "",
    referenceText ? "" : "",
    SHARE_SEPARATOR,
    "Shared from DharmaAnswers",
    "dharmaanswers.vercel.app",
    "This answer was generated by DharmaAnswers.",
  ]
    .filter(Boolean)
    .join("\n");

  return {
    ...emptyModel,
    displayQuestion,
    humanEntry,
    proofScripture,
    proofReference,
    proofVerse,
    proofVerseMeaning,
    hasCompactProof,
    primaryAnswer,
    immediateTakeaway,
    depthHook,
    deepAnswer: detailedAnswer,
    hasDeepLayer,
    languageLabel,
    responseStyleLabel,
    referenceText,
    scriptureText,
    footerDisclaimer,
    audioText,
    copiedText,
    fallbackText,
  };
}

export default function ScriptureAnswer({ content, question = "" }) {
  const [copied, setCopied] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallPhone, setIsSmallPhone] = useState(false);
  const [showDeepLayer, setShowDeepLayer] = useState(false);

  const answerModel = useMemo(
    () => buildAnswerModel(content, question),
    [content, question]
  );

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsSmallPhone(width <= 480);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    setFadeIn(true);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    setShowDeepLayer(false);
  }, [content, question]);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(answerModel.copiedText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      const textArea = document.createElement("textarea");
      textArea.value = answerModel.copiedText;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const markdownComponents = {
    h1: ({ children }) => <h1 style={styles.markdownH1(isMobile)}>{children}</h1>,
    h2: ({ children }) => <h2 style={styles.markdownH2(isMobile)}>{children}</h2>,
    h3: ({ children }) => <h3 style={styles.markdownH3(isMobile)}>{children}</h3>,
    p: ({ children }) => <p style={styles.markdownParagraph(isMobile)}>{children}</p>,
    blockquote: ({ children }) => (
      <blockquote style={styles.blockquote(isMobile)}>
        <div style={styles.blockquoteMark(isMobile)} aria-hidden="true">
          "
        </div>
        {children}
      </blockquote>
    ),
    ul: ({ children }) => <ul style={styles.list(isMobile)}>{children}</ul>,
    ol: ({ children }) => <ol style={styles.list(isMobile)}>{children}</ol>,
    li: ({ children }) => <li style={styles.listItem(isMobile)}>{children}</li>,
    strong: ({ children }) => {
      const strongText = flattenReactText(children);
      return (
        <strong
          style={
            isHeadingLikeStrong(strongText)
              ? styles.markdownStrongLabel(isMobile)
              : styles.markdownStrong
          }
        >
          {children}
        </strong>
      );
    },
    em: ({ children }) => <em style={styles.markdownEm}>{children}</em>,
    code: ({ inline, children }) =>
      inline ? (
        <code style={styles.inlineCode(isMobile)}>{children}</code>
      ) : (
        <pre style={styles.preBlock(isMobile)}>
          <code style={styles.codeBlock(isMobile)}>{children}</code>
        </pre>
      ),
    pre: ({ children }) => <pre style={styles.preBlock(isMobile)}>{children}</pre>,
    hr: () => <hr style={styles.rule} />,
  };

  const footerMarkdownComponents = {
    h1: ({ children }) => (
      <h4 style={styles.disclaimerHeading(isMobile)}>{children}</h4>
    ),
    h2: ({ children }) => (
      <h4 style={styles.disclaimerHeading(isMobile)}>{children}</h4>
    ),
    h3: ({ children }) => (
      <h4 style={styles.disclaimerHeading(isMobile)}>{children}</h4>
    ),
    p: ({ children }) => (
      <p style={styles.disclaimerParagraph(isMobile)}>{children}</p>
    ),
    strong: ({ children }) => (
      <strong style={styles.disclaimerStrong}>{children}</strong>
    ),
    em: ({ children }) => <em style={styles.disclaimerEm}>{children}</em>,
    ul: ({ children }) => <ul style={styles.disclaimerList(isMobile)}>{children}</ul>,
    ol: ({ children }) => <ol style={styles.disclaimerList(isMobile)}>{children}</ol>,
    li: ({ children }) => (
      <li style={styles.disclaimerListItem(isMobile)}>{children}</li>
    ),
  };

  return (
    <>
      <div style={styles.shell(isMobile, isSmallPhone, fadeIn)}>
        <div style={styles.backgroundPattern} />

        {!answerModel.isErrorResponse && answerModel.copiedText && (
          <div style={styles.copyButtonWrap(isMobile)}>
            <button
              type="button"
              style={styles.copyButton(isMobile, copied)}
              onClick={copyToClipboard}
            >
              <span>📜</span>
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        )}

        <header style={styles.hero(isMobile)}>
          <div style={styles.heroMark(isMobile)} aria-hidden="true">
            <div style={styles.heroMarkGlow} />
            <div style={styles.heroMarkIcon(isMobile)}>🕉️</div>
          </div>
          <h3 style={styles.heroTitle(isMobile)}>
            {answerModel.isErrorResponse ? "Something went wrong" : "Divine Wisdom"}
          </h3>
          <p style={styles.heroSubtitle(isMobile)}>
            {answerModel.isErrorResponse
              ? "We could not retrieve the scripture answer. Please try again."
              : "Ancient knowledge for modern life"}
          </p>
        </header>

        <div style={styles.heroDivider} />

        <main style={styles.contentFlow(isMobile)}>
          {answerModel.humanEntry && (
            <section style={styles.flowSection}>
              <h4 style={styles.sectionEyebrow(isMobile)}>
                A Human Reflection First
              </h4>
              <div style={styles.softPanel(isMobile)}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  components={markdownComponents}
                >
                  {answerModel.humanEntry}
                </ReactMarkdown>
              </div>
            </section>
          )}

          {answerModel.hasCompactProof && (
            <section style={styles.flowSection}>
              <div style={styles.proofBlock(isMobile)}>
                <div style={styles.proofMetaRow(isMobile)}>
                  {answerModel.proofScripture && (
                    <span style={styles.proofScripturePill(isMobile)}>
                      📖 {answerModel.proofScripture}
                    </span>
                  )}
                  {answerModel.proofReference && (
                    <span style={styles.proofReferenceText(isMobile)}>
                      {answerModel.proofReference}
                    </span>
                  )}
                </div>

                {answerModel.proofVerse && (
                  <div style={styles.proofVerseWrap(isMobile)}>
                    <p style={styles.proofVerseText(isMobile)}>
                      {answerModel.proofVerse}
                    </p>
                  </div>
                )}

                {answerModel.proofVerseMeaning && (
                  <p style={styles.proofMeaningText(isMobile)}>
                    {answerModel.proofVerseMeaning}
                  </p>
                )}
              </div>
            </section>
          )}

          {answerModel.primaryAnswer && (
            <section style={styles.flowSection}>
              <h4 style={styles.sectionEyebrow(isMobile)}>Primary Guidance</h4>
              <div style={styles.primaryNarrative(isMobile)}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  components={markdownComponents}
                >
                  {answerModel.primaryAnswer}
                </ReactMarkdown>
              </div>
            </section>
          )}

          {answerModel.immediateTakeaway && (
            <section style={styles.flowSection}>
              <div style={styles.takeawayBlock(isMobile)}>
                <div style={styles.takeawayLabel(isMobile)}>Immediate Takeaway</div>
                <p style={styles.takeawayText(isMobile)}>
                  {answerModel.immediateTakeaway}
                </p>
              </div>
            </section>
          )}

          {answerModel.hasDeepLayer && (
            <section style={styles.flowSection}>
              <button
                type="button"
                style={styles.depthToggle(isMobile, showDeepLayer)}
                onClick={() => setShowDeepLayer((value) => !value)}
              >
                {/* Live pulse rings — only when collapsed */}
                {!showDeepLayer && (
                  <>
                    <div style={styles.depthRing(1)} />
                    <div style={styles.depthRing(2)} />
                  </>
                )}

                <div style={styles.depthToggleMain(isMobile)}>
                  <div style={styles.depthToggleIcon(isMobile)}>
                    {/* Amber live dot — top-right of icon, only when collapsed */}
                    {!showDeepLayer && (
                      <div style={styles.depthLiveDotWrap}>
                        <div style={styles.depthLiveDotPing} />
                        <div style={styles.depthLiveDotCore} />
                      </div>
                    )}
                    {showDeepLayer ? "◉" : "✦"}
                  </div>

                  <div style={styles.depthToggleLabel(isMobile)}>
                    {showDeepLayer
                      ? "Hide Scriptural Depth"
                      : "See Full Dharmic Explanation"}
                  </div>
                  <div style={styles.depthToggleHint(isMobile)}>
                    {answerModel.depthHook ||
                      "Explore the verse, meaning, and deeper dharmic context behind this answer."}
                  </div>
                  <div style={styles.depthToggleMeta(isMobile)}>
                    {/* <span style={styles.depthToggleMetaItem(isMobile)}>Verse</span>
                    <span style={styles.depthToggleMetaDivider}>•</span>
                    <span style={styles.depthToggleMetaItem(isMobile)}>Meaning</span>
                    <span style={styles.depthToggleMetaDivider}>•</span>
                    <span style={styles.depthToggleMetaItem(isMobile)}>Context</span> */}
                  </div>
                </div>

                <span style={styles.depthToggleAction(isMobile, showDeepLayer)}>
                  <span style={styles.depthToggleSymbol(isMobile, showDeepLayer)}>
                    {showDeepLayer ? "−" : "+"}
                  </span>
                </span>
              </button>

              {showDeepLayer && (
                <div style={styles.depthPanel(isMobile)}>
                  <h4 style={styles.sectionEyebrow(isMobile)}>Scriptural Depth</h4>
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={markdownComponents}
                  >
                    {answerModel.deepAnswer}
                  </ReactMarkdown>
                </div>
              )}
            </section>
          )}
        </main>

        {!answerModel.isErrorResponse && answerModel.audioText && (
          <div style={styles.utilityBlock}>
            <AudioPlayer text={answerModel.audioText} isMobile={isMobile} compact={true} />
          </div>
        )}

        {!answerModel.isErrorResponse && (
          <footer style={styles.footer(isMobile)}>
            {answerModel.footerDisclaimer && (
              <div style={styles.disclaimerPanel(isMobile)}>
                <div style={styles.disclaimerPanelGlow} />
                <div style={styles.disclaimerBadge(isMobile)}>AI-assisted note</div>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  components={footerMarkdownComponents}
                >
                  {answerModel.footerDisclaimer}
                </ReactMarkdown>
              </div>
            )}

            <div style={styles.footerBottomRow(isMobile)}>
              <div style={styles.footerSource(isMobile)}>
                <span>📚</span>
                <span>
                  Source: {answerModel.scriptureText || "Hindu Scriptures"}
                </span>
              </div>
              <div style={styles.footerNote(isMobile)}>
                Ancient wisdom for modern life
              </div>
            </div>
          </footer>
        )}
      </div>

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700;800&family=Source+Serif+4:wght@400;500;600&display=swap");

        @keyframes depthRingPulse {
          0%   { opacity: 0.85; inset: -1px;  border-radius: 21px; }
          100% { opacity: 0;    inset: -14px; border-radius: 32px; }
        }

        @keyframes depthDotPing {
          0%   { transform: scale(1);   opacity: 0.9; }
          100% { transform: scale(3.4); opacity: 0;   }
        }

        @keyframes depthSymbolPop {
          0%, 100% { transform: scale(1);    }
          50%       { transform: scale(1.18); }
        }
      `}</style>
    </>
  );
}

const AMBER = "rgba(251, 191, 36,";

const styles = {
  shell: (isMobile, isSmallPhone, fadeIn) => ({
    width: "100%",
    background:
      "linear-gradient(135deg, #0a0a0a 0%, #17192b 45%, #1a2740 100%)",
    borderRadius: isSmallPhone ? "18px" : isMobile ? "22px" : "30px",
    padding: isSmallPhone ? "18px 16px" : isMobile ? "24px 20px" : "42px 40px",
    position: "relative",
    overflow: "hidden",
    border: "1px solid rgba(97, 218, 251, 0.14)",
    boxShadow:
      "0 28px 60px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 0 35px rgba(97, 218, 251, 0.07)",
    opacity: fadeIn ? 1 : 0,
    transform: fadeIn ? "translateY(0)" : "translateY(18px)",
    transition: "all 0.6s ease-out",
  }),

  backgroundPattern: {
    position: "absolute",
    inset: 0,
    background: `
      radial-gradient(circle at 18% 82%, rgba(97,218,251,0.05) 0%, transparent 46%),
      radial-gradient(circle at 82% 18%, rgba(148,187,233,0.05) 0%, transparent 44%),
      radial-gradient(circle at 48% 34%, rgba(97,218,251,0.04) 0%, transparent 52%)
    `,
    pointerEvents: "none",
    zIndex: 0,
  },

  copyButtonWrap: (isMobile) => ({
    position: "absolute",
    top: isMobile ? "14px" : "18px",
    right: isMobile ? "14px" : "18px",
    zIndex: 3,
  }),

  copyButton: (isMobile, copied) => ({
    background: copied
      ? "linear-gradient(135deg, rgba(72, 187, 120, 0.2) 0%, rgba(56, 161, 105, 0.2) 100%)"
      : "linear-gradient(135deg, rgba(97, 218, 251, 0.15) 0%, rgba(33, 161, 241, 0.15) 100%)",
    border: copied
      ? "1px solid rgba(72, 187, 120, 0.3)"
      : "1px solid rgba(97, 218, 251, 0.28)",
    color: copied ? "#7ce0a1" : "#61dafb",
    padding: isMobile ? "8px 14px" : "10px 18px",
    borderRadius: "999px",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: isMobile ? "0.8rem" : "0.9rem",
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    backdropFilter: "blur(10px)",
    boxShadow: copied
      ? "0 10px 30px rgba(72, 187, 120, 0.14)"
      : "0 8px 24px rgba(97, 218, 251, 0.12)",
  }),

  hero: (isMobile) => ({
    position: "relative",
    zIndex: 2,
    textAlign: "center",
    marginBottom: isMobile ? "12px" : "18px",
    paddingTop: isMobile ? "18px" : "4px",
  }),

  heroMark: (isMobile) => ({
    position: "relative",
    width: isMobile ? "46px" : "62px",
    height: isMobile ? "46px" : "62px",
    margin: "0 auto 14px",
  }),

  heroMarkGlow: {
    position: "absolute",
    inset: "8%",
    borderRadius: "16px",
    background:
      "radial-gradient(circle, rgba(97, 218, 251, 0.22) 0%, rgba(97, 218, 251, 0) 74%)",
    filter: "blur(10px)",
  },

  heroMarkIcon: (isMobile) => ({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: isMobile ? "34px" : "48px",
    lineHeight: 1,
    filter: "drop-shadow(0 0 20px rgba(97, 218, 251, 0.4))",
  }),

  heroTitle: (isMobile) => ({
    margin: 0,
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: isMobile ? "1.56rem" : "2.12rem",
    lineHeight: 1.08,
    fontWeight: 700,
    background: "linear-gradient(135deg, #61dafb 0%, #21a1f1 48%, #94bbe9 100%)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textShadow: "0 0 16px rgba(97, 218, 251, 0.2)",
  }),

  heroSubtitle: (isMobile) => ({
    margin: isMobile ? "6px 0 0" : "8px 0 0",
    color: "#94bbe9",
    fontSize: isMobile ? "0.84rem" : "1rem",
    fontStyle: "italic",
    fontWeight: 400,
    letterSpacing: "0.01em",
  }),

  heroDivider: {
    position: "relative",
    zIndex: 2,
    height: "1px",
    background:
      "linear-gradient(90deg, transparent, rgba(97, 218, 251, 0.25), transparent)",
    marginBottom: "18px",
  },

  utilityBlock: {
    position: "relative",
    zIndex: 2,
    marginTop: "6px",
    marginBottom: "18px",
  },

  contentFlow: (isMobile) => ({
    position: "relative",
    zIndex: 2,
    maxWidth: "920px",
    margin: "0 auto",
    color: "#edf4fb",
    fontFamily: "'Source Serif 4', Georgia, serif",
    fontSize: isMobile ? "1.07rem" : "1.28rem",
    lineHeight: 1.78,
  }),

  flowSection: {
    marginBottom: "22px",
  },

  proofBlock: (isMobile) => ({
    padding: isMobile ? "14px 16px" : "16px 18px",
    borderRadius: isMobile ? "14px" : "16px",
    background:
      "linear-gradient(135deg, rgba(97, 218, 251, 0.08) 0%, rgba(16, 28, 42, 0.72) 100%)",
    border: "1px solid rgba(97, 218, 251, 0.12)",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.12)",
  }),

  proofMetaRow: (isMobile) => ({
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: isMobile ? "8px" : "10px",
    marginBottom: isMobile ? "10px" : "12px",
  }),

  proofScripturePill: (isMobile) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: isMobile ? "6px 10px" : "7px 12px",
    borderRadius: "999px",
    background: "rgba(97, 218, 251, 0.12)",
    border: "1px solid rgba(97, 218, 251, 0.16)",
    color: "#a7ecff",
    fontSize: isMobile ? "0.8rem" : "0.84rem",
    fontWeight: 700,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  }),

  proofReferenceText: (isMobile) => ({
    color: "#c7dff3",
    fontSize: isMobile ? "0.82rem" : "0.88rem",
    fontWeight: 600,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  }),

  proofVerseWrap: (isMobile) => ({
    marginBottom: "10px",
    padding: isMobile ? "12px 14px" : "13px 16px",
    borderRadius: isMobile ? "12px" : "14px",
    background: "rgba(8, 14, 24, 0.72)",
    border: "1px solid rgba(97, 218, 251, 0.1)",
  }),

  proofVerseText: (isMobile) => ({
    margin: 0,
    color: "#eaf6ff",
    fontSize: isMobile ? "0.98rem" : "1.04rem",
    lineHeight: 1.7,
    fontWeight: 500,
    whiteSpace: "pre-wrap",
  }),

  proofMeaningText: (isMobile) => ({
    margin: 0,
    color: "#a9c2d8",
    fontSize: isMobile ? "0.88rem" : "0.94rem",
    lineHeight: 1.65,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    whiteSpace: "pre-wrap",
  }),

  sectionEyebrow: (isMobile) => ({
    margin: "0 0 16px",
    color: "#79d7ff",
    fontSize: isMobile ? "1.04rem" : "1.18rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  }),

  softPanel: (isMobile) => ({
    padding: 0,
    background: "transparent",
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
  }),

  primaryNarrative: (isMobile) => ({
    padding: 0,
    margin: 0,
  }),

  takeawayBlock: (isMobile) => ({
    padding: isMobile ? "14px 16px" : "15px 18px",
    borderRadius: isMobile ? "14px" : "16px",
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.028) 0%, rgba(97, 218, 251, 0.08) 100%)",
    border: "1px solid rgba(97, 218, 251, 0.12)",
  }),

  takeawayLabel: (isMobile) => ({
    marginBottom: "8px",
    color: "#9ee6ff",
    fontSize: isMobile ? "0.8rem" : "0.84rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  }),

  takeawayText: (isMobile) => ({
    margin: 0,
    color: "#edf4fb",
    fontSize: isMobile ? "0.98rem" : "1.04rem",
    lineHeight: 1.68,
  }),

  // ─── DEPTH TOGGLE — NEW LIVE AMBER DESIGN ───────────────────────────────────

  depthToggle: (isMobile, isOpen) => ({
    width: "100%",
    background:
      "linear-gradient(135deg, rgba(18, 22, 36, 0.97) 0%, rgba(22, 28, 44, 0.99) 100%)",
    // Amber border when collapsed, subtle blue-ish when open
    border: isOpen
      ? "1.5px solid rgba(97, 218, 251, 0.18)"
      : `1.5px solid ${AMBER} 0.28)`,
    borderRadius: isMobile ? "18px" : "20px",
    padding: isMobile ? "13px 14px" : "14px 18px",
    color: "#e8f6ff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: isMobile ? "12px" : "16px",
    cursor: "pointer",
    textAlign: "left",
    position: "relative",
    overflow: "visible",
    boxShadow: isOpen
      ? "0 8px 24px rgba(0,0,0,0.2)"
      : `0 0 28px ${AMBER} 0.1), 0 8px 24px rgba(0,0,0,0.2)`,
    transition: "border 0.35s ease, box-shadow 0.35s ease",
  }),

  // Animated rings rendered as inline divs (no className needed)
  depthRing: (order) => ({
    position: "absolute",
    inset: "-1px",
    borderRadius: "21px",
    border: `1.5px solid ${AMBER} 0.65)`,
    opacity: 0,
    pointerEvents: "none",
    animation: `depthRingPulse 2.4s ease-out ${order === 2 ? "1.2s" : "0s"} infinite`,
  }),

  depthLiveDotWrap: {
    position: "absolute",
    top: "7px",
    right: "7px",
    width: "9px",
    height: "9px",
  },

  depthLiveDotCore: {
    width: "9px",
    height: "9px",
    borderRadius: "50%",
    background: "#0ac2f5",
    position: "absolute",
    top: 0,
    left: 0,
  },

  depthLiveDotPing: {
    width: "9px",
    height: "9px",
    borderRadius: "50%",
    background: `${AMBER} 0.5)`,
    position: "absolute",
    top: 0,
    left: 0,
    animation: "depthDotPing 1.9s ease-out infinite",
  },

  depthToggleMain: (isMobile) => ({
    display: "grid",
    gridTemplateColumns: isMobile ? "42px 1fr" : "46px 1fr",
    columnGap: isMobile ? "10px" : "12px",
    rowGap: "2px",
    alignItems: "center",
    flex: 1,
    minWidth: 0,
  }),

  depthToggleIcon: (isMobile) => ({
    width: isMobile ? "42px" : "46px",
    height: isMobile ? "42px" : "46px",
    borderRadius: isMobile ? "13px" : "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#f4d134",
    fontSize: isMobile ? "1.05rem" : "1.15rem",
    background:
      "linear-gradient(180deg, rgba(25, 73, 101, 0.88) 0%, rgba(14, 37, 58, 0.94) 100%)",
    border: "1px solid rgba(97, 218, 251, 0.14)",
    boxShadow:
      "0 0 18px rgba(55, 183, 255, 0.12), inset 0 0 18px rgba(97, 218, 251, 0.06)",
    gridRow: "1 / span 3",
    position: "relative", // needed for live dot absolute positioning
  }),

  depthToggleLabel: (isMobile) => ({
    fontSize: isMobile ? "1.02rem" : "1.14rem",
    fontWeight: 700,
    color: "#dff6ff",
    marginBottom: "2px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    lineHeight: 1.25,
    textShadow: "0 0 10px rgba(97, 218, 251, 0.14)",
  }),

  depthToggleHint: (isMobile) => ({
    color: "#a8c5db",
    fontSize: isMobile ? "0.84rem" : "0.93rem",
    lineHeight: 1.42,
    marginBottom: "6px",
  }),

  depthToggleMeta: (isMobile) => ({
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "6px" : "8px",
    flexWrap: "wrap",
    color: "#77dfff",
    fontSize: isMobile ? "0.74rem" : "0.78rem",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    opacity: 0.92,
  }),

  depthToggleMetaItem: (isMobile) => ({
    display: "inline-flex",
    alignItems: "center",
    padding: isMobile ? "2px 7px" : "3px 8px",
    borderRadius: "999px",
    background: "rgba(97, 218, 251, 0.08)",
    border: "1px solid rgba(97, 218, 251, 0.1)",
    boxShadow: "0 0 12px rgba(55, 183, 255, 0.06)",
    whiteSpace: "nowrap",
  }),

  depthToggleMetaDivider: {
    color: "rgba(121, 215, 255, 0.64)",
    fontSize: "0.8em",
  },

  depthToggleAction: (isMobile, isOpen) => ({
    width: isMobile ? "42px" : "46px",
    height: isMobile ? "42px" : "46px",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    background: isOpen
      ? "linear-gradient(180deg, rgba(38, 88, 120, 0.96) 0%, rgba(20, 49, 74, 0.96) 100%)"
      : `linear-gradient(180deg, ${AMBER} 0.22) 0%, ${AMBER} 0.14) 100%)`,
    border: isOpen
      ? "1px solid rgba(117, 226, 255, 0.18)"
      : `1px solid ${AMBER} 0.40)`,
    boxShadow: isOpen
      ? "0 0 22px rgba(55, 183, 255, 0.14), inset 0 0 16px rgba(255,255,255,0.03)"
      : `0 0 18px ${AMBER} 0.20)`,
    transition: "background 0.35s ease, border 0.35s ease, box-shadow 0.35s ease",
  }),

  depthToggleSymbol: (isMobile, isOpen) => ({
    color: isOpen ? "#d9f7ff" : "#24fbed",
    fontSize: isMobile ? "1.45rem" : "1.65rem",
    fontWeight: 600,
    lineHeight: 1,
    textShadow: isOpen
      ? "0 0 14px rgba(97, 218, 251, 0.18)"
      : `0 0 14px ${AMBER} 0.4)`,
    animation: isOpen ? "none" : "depthSymbolPop 2s ease-in-out infinite",
    display: "block",
  }),

  // ─── END DEPTH TOGGLE ────────────────────────────────────────────────────────

  depthPanel: (isMobile) => ({
    marginTop: "12px",
    padding: 0,
    background: "rgba(255, 255, 255, 0.015)",
    border: "none",
    borderRadius: isMobile ? "12px" : "14px",
    boxShadow: "none",
  }),

  footer: (isMobile) => ({
    position: "relative",
    zIndex: 2,
    marginTop: "34px",
    paddingTop: "24px",
    borderTop: "1px solid rgba(97, 218, 251, 0.16)",
  }),

  disclaimerPanel: (isMobile) => ({
    position: "relative",
    display: "block",
    padding: isMobile ? "18px" : "20px 22px",
    borderRadius: isMobile ? "16px" : "18px",
    background:
      "linear-gradient(135deg, rgba(10, 16, 25, 0.95) 0%, rgba(16, 23, 36, 0.96) 58%, rgba(12, 18, 29, 0.98) 100%)",
    border: "1px solid rgba(148, 187, 233, 0.12)",
    boxShadow:
      "0 14px 30px rgba(0, 0, 0, 0.16), inset 0 1px 0 rgba(255,255,255,0.02), inset 3px 0 0 rgba(97, 218, 251, 0.18)",
    overflow: "hidden",
  }),

  disclaimerPanelGlow: {
    position: "absolute",
    inset: 0,
    background:
      "radial-gradient(circle at top right, rgba(97, 218, 251, 0.08) 0%, transparent 34%), radial-gradient(circle at bottom left, rgba(148, 187, 233, 0.06) 0%, transparent 28%)",
    pointerEvents: "none",
  },

  disclaimerBadge: (isMobile) => ({
    position: "relative",
    zIndex: 1,
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    marginBottom: "12px",
    padding: isMobile ? "6px 10px" : "7px 12px",
    borderRadius: "999px",
    background: "rgba(97, 218, 251, 0.08)",
    border: "1px solid rgba(97, 218, 251, 0.14)",
    color: "#9edfff",
    fontSize: isMobile ? "0.76rem" : "0.8rem",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.03)",
  }),

  disclaimerHeading: (isMobile) => ({
    position: "relative",
    zIndex: 1,
    margin: "0 0 10px",
    color: "#d4f2ff",
    fontSize: isMobile ? "0.96rem" : "1.02rem",
    fontWeight: 700,
    letterSpacing: "0.02em",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  }),

  disclaimerParagraph: (isMobile) => ({
    position: "relative",
    zIndex: 1,
    margin: 0,
    color: "#9fb7ce",
    fontSize: isMobile ? "0.85rem" : "0.91rem",
    lineHeight: 1.72,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  }),

  disclaimerStrong: {
    color: "#ccefff",
    fontWeight: 700,
  },

  disclaimerEm: {
    color: "#a8dbff",
    fontStyle: "italic",
  },

  disclaimerList: (isMobile) => ({
    margin: "8px 0 0",
    paddingLeft: isMobile ? "18px" : "20px",
    color: "#8fa8c1",
  }),

  disclaimerListItem: (isMobile) => ({
    marginBottom: "6px",
    fontSize: isMobile ? "0.84rem" : "0.9rem",
    lineHeight: 1.65,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  }),

  footerBottomRow: (isMobile) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: isMobile ? "flex-start" : "center",
    flexDirection: isMobile ? "column" : "row",
    gap: isMobile ? "10px" : "18px",
    marginTop: "18px",
  }),

  footerSource: (isMobile) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    color: "#a8c1d7",
    fontSize: isMobile ? "0.92rem" : "1rem",
  }),

  footerNote: (isMobile) => ({
    color: "#61dafb",
    fontSize: isMobile ? "0.9rem" : "0.98rem",
    fontStyle: "italic",
    fontWeight: 600,
  }),

  markdownH1: (isMobile) => ({
    margin: "0 0 18px",
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: isMobile ? "1.7rem" : "2rem",
    color: "#7fdcff",
    lineHeight: 1.2,
    textShadow: "0 0 18px rgba(97, 218, 251, 0.16)",
  }),

  markdownH2: (isMobile) => ({
    margin: "24px 0 14px",
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: isMobile ? "1.45rem" : "1.65rem",
    color: "#7fdcff",
    lineHeight: 1.28,
    textShadow: "0 0 14px rgba(97, 218, 251, 0.12)",
  }),

  markdownH3: (isMobile) => ({
    margin: "20px 0 12px",
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: isMobile ? "1.2rem" : "1.35rem",
    color: "#9adfff",
    lineHeight: 1.34,
    textShadow: "0 0 12px rgba(97, 218, 251, 0.1)",
  }),

  markdownParagraph: (isMobile) => ({
    margin: "0 0 22px",
    color: "#e6edf8",
    fontSize: isMobile ? "1.05rem" : "1.26rem",
    lineHeight: 1.78,
    textAlign: "left",
  }),

  markdownStrong: {
    color: "#67d8ff",
    fontWeight: 700,
    textShadow: "0 0 10px rgba(97, 218, 251, 0.16)",
  },

  markdownStrongLabel: (isMobile) => ({
    display: "inline-block",
    padding: isMobile ? "3px 10px 5px" : "4px 12px 6px",
    marginRight: "8px",
    marginBottom: "4px",
    borderRadius: "10px",
    background:
      "linear-gradient(180deg, rgba(30, 78, 112, 0.96) 0%, rgba(18, 48, 71, 0.92) 100%)",
    border: "1px solid rgba(117, 226, 255, 0.16)",
    boxShadow:
      "0 0 0 1px rgba(255, 255, 255, 0.02) inset, 0 0 20px rgba(60, 189, 255, 0.14)",
    color: "#79e3ff",
    fontWeight: 700,
    letterSpacing: "0.01em",
    lineHeight: 1.25,
    textShadow: "0 0 12px rgba(97, 218, 251, 0.22)",
    verticalAlign: "baseline",
  }),

  markdownEm: {
    color: "#9ed4ff",
    fontStyle: "italic",
  },

  blockquote: (isMobile) => ({
    position: "relative",
    margin: "26px 0",
    padding: isMobile ? "18px 18px 18px 24px" : "24px 28px 24px 30px",
    borderRadius: "18px",
    border: "1px solid rgba(97, 218, 251, 0.16)",
    background:
      "linear-gradient(135deg, rgba(97, 218, 251, 0.08) 0%, rgba(148, 187, 233, 0.06) 100%)",
    color: "#f2fbff",
  }),

  blockquoteMark: (isMobile) => ({
    position: "absolute",
    left: isMobile ? "8px" : "10px",
    top: isMobile ? "-4px" : "-8px",
    color: "rgba(97, 218, 251, 0.3)",
    fontSize: isMobile ? "2.2rem" : "3rem",
    fontFamily: "Georgia, serif",
    lineHeight: 1,
  }),

  list: (isMobile) => ({
    paddingLeft: isMobile ? "20px" : "26px",
    margin: "18px 0 24px",
  }),

  listItem: (isMobile) => ({
    marginBottom: "10px",
    color: "#e6edf8",
    fontSize: isMobile ? "1.02rem" : "1.2rem",
    lineHeight: 1.7,
  }),

  inlineCode: (isMobile) => ({
    background: "rgba(97, 218, 251, 0.1)",
    color: "#7fdcff",
    borderRadius: "6px",
    padding: isMobile ? "2px 6px" : "3px 8px",
    fontSize: isMobile ? "0.92rem" : "0.98rem",
    fontFamily: "'Fira Code', 'Courier New', monospace",
  }),

  preBlock: (isMobile) => ({
    background: "rgba(11, 18, 30, 0.9)",
    border: "1px solid rgba(97, 218, 251, 0.16)",
    borderRadius: "18px",
    padding: isMobile ? "16px 16px" : "20px 22px",
    margin: "24px 0",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  }),

  codeBlock: (isMobile) => ({
    color: "#d8f7ff",
    fontSize: isMobile ? "0.98rem" : "1.08rem",
    fontFamily: "'Fira Code', 'Courier New', monospace",
    whiteSpace: "pre",
    lineHeight: 1.7,
  }),

  rule: {
    border: "none",
    height: "1px",
    background:
      "linear-gradient(90deg, transparent, rgba(97, 218, 251, 0.24), transparent)",
    margin: "28px 0",
  },
};